/* tslint:disable */
import { Injectable, Injector } from '@angular/core';
import { HttpService } from "../../http.service";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { MarkersService } from "../markers/markers.service";
import { LayoutService } from "../layout/layout.service";
import { AlertService } from "../../alert.service";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private urlLogin = environment.apiURL + 'usermanagement_login';
    private urlLogout = environment.apiURL + 'usermanagement_logout';
    private urlGetUserData = environment.apiURL + 'usermanagement_get_user_data';
    private urlUpdatePassword = environment.apiURL + 'usermanagement_update_password';

    subjectIsUserAuthenticated = new BehaviorSubject<boolean|null>(null);
    subjectIsUserAdmin = new BehaviorSubject(false);
    subjectUserData = new BehaviorSubject<any>(null);

    _isUserAuthenticated = false;
    _isUserAdmin = false;

    user: any = null;

    constructor(
        private httpService: HttpService,
        private injector: Injector,
        private alertService: AlertService
    ) {
        this.getUserData();
        this.listenToUserStatus();
    }

    login(loginData) {
        return this.httpService
            .postRequest(this.urlLogin, { loginData: loginData })
            .subscribe(
                result => {
                    if (result.success) {
                        this.getUserData();  // Fetch user data after successful login
                        loginData.username = '';
                        loginData.password = '';
                    } else {
                        this.alertService.showErrorMsg('USERNAME_OR_PASSWORD_WRONG');
                    }
                },
                error => {
                    this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                }
            );
    }

    getUserData() {
        this.httpService.getRequest(this.urlGetUserData).subscribe(
            (result) => {
                if (result.success) {
                    this.setUserData(result.user_data);
                } else {
                    // Only call logout if user was already logged in
                    if (this._isUserAuthenticated) {
                        this.handleLogout();
                    }
                }
            },
            (error) => {
                if (error.status === 401 || error.status === 403) {
                    if (this._isUserAuthenticated) {
                        this.handleLogout();
                    }
                    // Else, silently skip logout — user was not logged in
                } else {
                    this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                }
            }
        );
    }


    setUserData(userData) {
        this.user = userData;
        this.subjectUserData.next(this.user);
        const markersService = this.injector.get<MarkersService>(MarkersService);
        const layoutService = this.injector.get<LayoutService>(LayoutService);

        if (layoutService.viewOptions.twoD) {
            markersService.setFavouriteMarkers(this.user.saved_data.favourite_markers_ids);
        }

        this.setAuthenticated(true);
        this.setAdmin(this.user.is_admin);
    }

    logout() {
        this.httpService.postRequest(this.urlLogout, {}).subscribe(
            (result) => {
                if (result.success) {
                    this.handleLogout();
                } else {
                    this.alertService.showErrorMsg('LOGOUT_FAILED');
                }
            },
            (error) => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
            }
        );
    }

    handleLogout() {
        this.user = null;
        this.subjectUserData.next(null);
        this.setAuthenticated(false);
        this.setAdmin(false);
    }

    setAuthenticated(isAuthenticated: boolean) {
        this._isUserAuthenticated = isAuthenticated;
        this.subjectIsUserAuthenticated.next(this._isUserAuthenticated);
    }

    setAdmin(isAdmin: boolean) {
        this._isUserAdmin = isAdmin;
        this.subjectIsUserAdmin.next(this._isUserAdmin);
    }

    listenToUserStatus() {
        this.subjectIsUserAuthenticated.subscribe((isAuthenticated) => {
            this._isUserAuthenticated = isAuthenticated;
        });
    }

    isUserAuthenticated() {
        return this._isUserAuthenticated;
    }

    updatePassword(oldPassword: string, newPassword: string): Observable<any> {
        return this.httpService.postRequest(this.urlUpdatePassword, {
            update_password_data: {
                oldPassword: oldPassword,
                newPassword: newPassword
            }
        });
    }
}
